import { render, staticRenderFns } from "./MarkTaskManage.vue?vue&type=template&id=392bdcb5&scoped=true&"
import script from "./MarkTaskManage.vue?vue&type=script&lang=js&"
export * from "./MarkTaskManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bdcb5",
  null
  
)

export default component.exports